import AuthWrapper from 'components/AuthWrapper';
import PageWrapper from 'components/PageWrapper';
import Profile from 'components/Account/Profile';

export default function ProfilePage() {
  return (
    <AuthWrapper>
      <PageWrapper page={[]} isFixed={false}>
        <Profile />
      </PageWrapper>
    </AuthWrapper>
  );
}
